import React from 'react'
import { NavLink } from 'react-router-dom'
import '../assets/css/footer.css'
import { CiLocationOn } from "react-icons/ci";
import {
  FaFacebookF,
  FaTelegramPlane,
  FaInstagram,
  FaPinterestP,

} from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import { BsTelephone } from "react-icons/bs";
import footerLogo from "../assets/images/logo.png"
const Footer = () => {
  return (
    <footer className="footer-section margin-before">
      <div className="container py-5">
        <div className="row gy-4">
          {/* Logo & Description */}
          <div className="col-md-3">
            <img
              src={footerLogo}
              alt="Trivom Tara"
              className="mb-3 footer-logo"
            />
            <p className="text-dark text-[16px]">
              Ready to embrace positivity and prosperity? Triangle Vastu offers
              easy online and onsite consultations, tailored for your.
            </p>
          </div>

          {/* About */}
          <div className="col-md-2">
            <h6 className="text-lora font-semibold mb-3 text-[20px] ">Quick Links</h6>
            <ul className="list-unstyled">
              <li><NavLink to="/" className="footer-link">Home</NavLink></li>
              <li><NavLink to="/about" className="footer-link">About Us</NavLink></li>
              <li><NavLink to="/services" className="footer-link">Service</NavLink></li>
              <li><NavLink to="/shop" className="footer-link">Shop</NavLink></li>
              <li><NavLink to="/training-classes" className="footer-link">Training Classes</NavLink></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="col-md-2">
            <h6 className="text-lora font-semibold mb-3 text-[20px]">Quick Links</h6>
            <ul className="list-unstyled">
              <li><NavLink to="/news-articles" className="footer-link">News & Article</NavLink></li>
              <li><NavLink to="/contact" className="footer-link">Contact Us</NavLink></li>
              <li><NavLink to="#" className="footer-link">Privacy Policy</NavLink></li>
              <li><NavLink to="#" className="footer-link">Terms Of Use</NavLink></li>
              <li><NavLink to="#" className="footer-link">Term & Conditions</NavLink></li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div className="col-md-5">
            <h6 className="text-lora font-semibold mb-3 text-[20px]">Contacts</h6>
            <div className='flex items-center mb-1'>
              <MdOutlineMail className='me-2' />
              <NavLink to='mailto:vastutriangle559@gmail.com' className="mb-1 no-underline text-gray-900">
                vastutriangle559@gmail.com
              </NavLink>
            </div>
            <div className='flex items-center mb-2'>
              <BsTelephone className='me-2' />
              <span className="mb-1">
                <a href="tel:2659652695" className='no-underline text-gray-900'> +91 2659652695</a>
              </span>
            </div>
            <div className=" mb-4 address-block">
              <div className="flex items-center mb-2">
                <CiLocationOn className=" me-1" size={24} />
                <p className="mb-0 text-dark">
                  H-Block, Sector-63, Noida, Uttar Pradesh,  201301, India
                </p>
              </div>

            </div>
            <h5 className="text-lora font-semibold lg:text-[24px]">Follow Us</h5>
            <div className="d-flex gap-3 mt-2">
              <a href="#" className="social-icon"><FaFacebookF /></a>
              <a href="#" className="social-icon"><FaTelegramPlane /></a>
              <a href="#" className="social-icon"><FaInstagram /></a>
              <a href="#" className="social-icon"><FaPinterestP /></a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom text-center py-2">
        <small>©2025 Triangle Vastu All Rights Reserved</small>
      </div>
    </footer>
  )
}

export default Footer